export default {
    connectedAppStoreAccounts(state) {
        return state.connectedAppStoreAccounts
    },
    authUrl(state) {
        return state.authUrl;
    },
    packages(state){
        return state.packages;
    }
}
